import { z } from "zod";
import { SocialPlatformZ } from "../util/social-links";

export const UserSocialLinkZ = z.object({
  platform: SocialPlatformZ,
  value: z.string(),
});
export type UserSocialLink = z.infer<typeof UserSocialLinkZ>;

export type LightnessTheme = "light" | "dark" | "system";
